export const Constants = {
  BEACON_ANCHOR_NAVIGATION: '[beacon-tag-name="beacon-anchor-navigation"]',
  BEACON_ANCHOR_NAVIGATION_TAB_BAR: '.tab-bar',
  POP_SUMMARY_STICKY_HEADER_CONTAINER: '.pop-summary-sticky-header-container',
  SCROLL: 'scroll',
  STICKY: 'sticky',
  STICKY_TITLE_CONTAINER: '.sticky-title-search',
  SUMMARY_SEARCH_CONTAINER: '.summary-search-container',
  TAG_NAME: 'pop-summary-sticky-header-component',
  ZERO_PX: '0px',
} as const;
